import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NetworkAwarePreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    const isMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);

    if (
      navigator.connection?.saveData ||
      isMobile ||
      ['slow-2g', '2g', '3g'].includes(navigator.connection?.effectiveType ?? '') ||
      route.data?.['preload'] === false
    ) {
      return of(null);
    }

    return load();
  }
}
